import * as React from 'react';

import { isValidEmail } from '@cian/valuation-utils-component';

import { IFeedbackFormContainerState } from '../FeedbackFormContainer';
import { clearPhone } from '../../../components/Feedback/Form/utils';

export function useFormValidator(
  state: IFeedbackFormContainerState,
  updateState: (state: IFeedbackFormContainerState) => void,
) {
  return React.useCallback(() => {
    const { name, phone, email, comment } = state;
    const sanitizePhone = clearPhone(phone);

    if (!name) {
      updateState({ ...state, nameError: true });

      return false;
    }

    if (!email || !isValidEmail(email)) {
      updateState({ ...state, emailError: true });

      return false;
    }

    if (sanitizePhone.length < 10) {
      updateState({ ...state, phoneError: true });

      return false;
    }

    if (!comment.trim()) {
      updateState({ ...state, commentError: true });

      return false;
    }

    return true;
  }, [state, updateState]);
}
